import { CheckIcon } from '@slal/ui/icons';
import { Line, ProgressBar, ProgressIndicator, StepContainer, StepIndicatorText } from './styles';
import { ProgressStepProps, StepState } from './types';

function getStepState(step: number, currentStep: number): StepState {
    const stepState: Record<number, StepState> = {
        [-1]: 'previous',
        [0]: 'current',
        [1]: 'next',
    };
    return stepState[Math.sign(step - currentStep)] ?? 'next';
}

export function ProgressStep({ currentStep, totalSteps }: ProgressStepProps) {
    return (
        <ProgressBar>
            {[...Array(totalSteps)].map((_, idx) => {
                const stepNumber = idx + 1;
                const state = getStepState(stepNumber, currentStep);
                const isCompleted = state === 'previous';
                const isActive = state === 'current';

                return (
                    <StepContainer key={idx}>
                        <ProgressIndicator
                            state={state}
                            role="status"
                            aria-current={isActive ? 'step' : undefined}
                            aria-label={`Step ${stepNumber} ${state}`}
                        >
                            {isCompleted && <CheckIcon />}
                        </ProgressIndicator>
                        {idx < totalSteps - 1 && <Line isCompleted={isCompleted} />}
                        <StepIndicatorText>Step {stepNumber}</StepIndicatorText>
                    </StepContainer>
                );
            })}
        </ProgressBar>
    );
}
